// Aviso tras pedir una impresión a la impresora de tickets. Mismo criterio en todas las pantallas
// que imprimen (Ventas, Balance): 200 ya se mandó a imprimir, 701 el agente de impresión no está
// conectado, cualquier otro código es un error. Antes, «Imprimir» en Balance ignoraba la respuesta
// y sin impresora no pasaba nada visible.
export const DEVICE_NOT_CONNECTED = 701;

export function printFeedback(response) {
    const status = response ? response.status : undefined;
    if (status === 200) {
        return { severity: 'success', summary: 'Imprimiendo...', detail: '', life: 3000 };
    }
    if (status === DEVICE_NOT_CONNECTED) {
        return { severity: 'error', summary: 'Dispositivo no conectado',
                 detail: 'Asegurese que su dispositivo este conectado y configurado', life: 10000 };
    }
    const detail = (response && response.error)
        ? response.error
        : 'Por favor contacte a soporte para la solución de este problema.';
    return { severity: 'error', summary: 'Error imprimiendo', detail: detail, life: 10000 };
}
